/**
 * Node globals that some bundled dependencies expect.
 *
 * With the webpack builder this was done by `webpack.config.js`: a `ProvidePlugin` injected `process`
 * and `resolve.fallback` swapped Node modules for their browser equivalents. The esbuild builder
 * (`@angular/build:application`) polyfills nothing: whatever a dependency expects to find on the
 * global must be set here, and it loads before zone.js (see `polyfills` in angular.json).
 *
 * Only assigned when missing: a real browser has no `globalThis.process`, but a future test or SSR
 * environment does, and overwriting it would be worse.
 */
import process from 'process';
import { Buffer } from 'buffer';

type NodeGlobals = typeof globalThis & {
  process?: unknown;
  Buffer?: unknown;
  global?: unknown;
};

const scope = globalThis as NodeGlobals;

// `define` in angular.json also resolves `global` for the dependencies' already compiled code;
// this covers dynamic accesses (`globalThis['global']`) that `define` does not see.
scope.global ??= globalThis;
scope.process ??= process;
scope.Buffer ??= Buffer;
